<template>
    <header class="header">
        <div class="header-nav--left">
            <NavLeft />
        </div>
        <div class="header-nav--right">
            <NavRight />
        </div>
    </header>
</template>

<script>
    import {logout} from '@/helpers/helpers'
    import NavLeft from './NavLeft'
    import NavRight from './NavRight'

    export default {
        name: 'navbar',
        components: {
            NavLeft,  
            NavRight  
        },
        data() {
            return {
                activeIndex: 'home'
            }
        },
        methods: {
            logout,
            handleSelect(param) {
                this.$router.push('/dashboard/' + param)
            }
        }
    }
</script>

<style scoped>
    .header {
        position: fixed;
        z-index: 6;
        width: 100%;
        height: 60px;
        background-color: #21262e;
        box-shadow: 0 2px 5px 0 rgba(0,0,0,.16), 0 2px 10px 0 rgba(0,0,0,.12);
    }
    
    .header-nav--left,
    .header-nav--right {
        display: inline-block;
    }

    .header-nav--left {
        width: 200px;
        height: 100%;
        position: relative;
    }
    
    .header-nav--right {
        float: right;
        padding-right: 25px;
        line-height: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Headers/Navbar.vue